import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BeneficiaryCardRow } from '@shared/components';
import { ButtonModule } from '@vg-constellation/angular-16/button';
import { LinkModule } from '@vg-constellation/angular-16/link';

@Component({
  selector: 'app-beneficiary-card',
  templateUrl: './beneficiary-card.component.html',
  styleUrls: ['./beneficiary-card.component.scss'],
  standalone: true,
  imports: [ButtonModule, LinkModule],
})
export class BeneCardComponent {
  @Input() public content: any;
  @Input() public beneCardData: BeneficiaryCardRow;
  @Input() public showRemoveButton: boolean = false;
  @Output() public removeCard: EventEmitter<BeneficiaryCardRow> =
    new EventEmitter<BeneficiaryCardRow>();
  @Output() public editCard: EventEmitter<void> = new EventEmitter<void>();

  public edit(): void {
    this.editCard.emit();
  }

  public remove(): void {
    this.removeCard.emit(this.beneCardData);
  }
}
